import { EventEmitter, inject, Injectable } from '@angular/core';
import { CheckoutValidator, ValidationErrorKeys, ValidationErrors } from '@checkout-v2/const';
import { PickupFacade } from '@checkout-v2/data-access';
import { ShopListFacade } from '@shop/data-access';
import { ShopListService } from '@shop/feature';
import { combineLatest, map, Observable, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PickupService extends CheckoutValidator {
  private readonly shopListService = inject(ShopListService);
  private readonly pickupFacade = inject(PickupFacade);
  private readonly shopListFacade = inject(ShopListFacade);

  activeShopId$ = this.pickupFacade.getActiveShopId();
  activeShop$ = this.pickupFacade.getActiveShopId().pipe(switchMap((id) => this.shopListFacade.getShop(id)));

  setShopEvent = new EventEmitter<string>();

  setShop(id: string | undefined): void {
    this.pickupFacade.setShop(id);
    this.setShopEvent.emit(id);
  }

  isEmptyOrHasError(): Observable<boolean> {
    return this.shopListService.shopsState$.pipe(
      map((state) => !!state.error || (!!state.value && state.value.length === 0)),
    );
  }

  getValidationErrors(): Observable<ValidationErrors> {
    return combineLatest({
      isEmptyOrHasError: this.isEmptyOrHasError(),
      activeShop: this.activeShop$,
    }).pipe(
      map(({ isEmptyOrHasError, activeShop }) => {
        const validationErrors: ValidationErrors = {};

        if (!isEmptyOrHasError && !activeShop) {
          validationErrors[ValidationErrorKeys.PICKUP_ADDRESS_REQUIRED] = 'выберите адрес самовывоза';
        }

        return validationErrors;
      }),
    );
  }
}
